import React, { Component } from 'react';
import { Form, DatePicker } from 'antd';

const { MonthPicker } = DatePicker;

class MonthRange extends Component {
  state = {
    startValue: this.props.startValue,
    endValue: this.props.endValue,
    endOpen: false,
  };

  disabledStartDate = startValue => {
    const { endValue } = this.state;
    if (!startValue || !endValue) {
      return false;
    }
    return startValue.valueOf() >= endValue.valueOf();
  };

  disabledEndDate = endValue => {
    const { startValue } = this.state;
    if (!endValue || !startValue) {
      return false;
    }
    return endValue.valueOf() <= startValue.valueOf();
  };

  onChange = (field, value) => {
    this.setState(
      {
        [field]: value,
      },
      () => {
        const date = [];
        date.push(this.state.startValue);
        date.push(this.state.endValue);
        this.props.transferValue(date);
      },
    );
  };

  onStartChange = value => {
    this.onChange('startValue', value);
  };

  onEndChange = value => {
    this.onChange('endValue', value);
  };

  handleStartOpenChange = open => {
    if (!open) {
      this.setState({ endOpen: true });
    }
  };

  handleEndOpenChange = open => {
    this.setState({ endOpen: open });
  };

  render() {
    const { startValue, endValue, endOpen } = this.state;
    return (
      <div>
        <MonthPicker
          disabledDate={this.disabledStartDate}
          showTime
          format="YYYY-MM"
          value={startValue}
          placeholder="Start"
          onChange={this.onStartChange}
          onOpenChange={this.handleStartOpenChange}
        />
        -
        <MonthPicker
          disabledDate={this.disabledEndDate}
          showTime
          format="YYYY-MM"
          value={endValue}
          placeholder="End"
          onChange={this.onEndChange}
          open={endOpen}
          onOpenChange={this.handleEndOpenChange}
        />
      </div>
    );
  }
}

export default Form.create()(MonthRange);



// WEBPACK FOOTER //
// ./src/components/comm/MonthRangePicker.js